import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日焦点", href: "#focus" },
  { label: "频道围观", href: "#channels" },
  { label: "大瓜合集", href: "#roundup" },
  { label: "群组讨论", href: "#forum" },
  { label: "热议排行", href: "#rank" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-soft" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* Brand */}
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-base font-bold text-background-50">
            瓜
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950">
            吃瓜<span className="text-primary-600">聚集地</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-full px-3 py-2 text-sm text-foreground-700 transition hover:bg-primary-100/70 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Desktop actions */}
        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#forum"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 px-4 py-2 text-sm font-medium text-primary-700 transition hover:bg-primary-100/70"
          >
            <i className="ri-user-add-line text-base" aria-hidden="true"></i>
            加入围观
          </a>
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
            开始吃瓜
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2 text-sm text-foreground-700 transition hover:bg-primary-100/70"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-2 flex flex-col gap-2">
              <a
                href="#forum"
                className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50"
              >
                加入围观
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}